import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PriceCalc from './PriceCalc.js';
import './pricing.css';
import Paper from '@material-ui/core/Paper';
import AppGrid from './AppsGrid.js';
import AppsGrid from './AppsGrid.js';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import green from '@material-ui/core/colors/green';
import SupportGrid from './SupportGrid.js';
import PackGrid from './PackGrid.js';
import MainConfirmation from './MainConfirmation.js'
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { withSnackbar } from 'notistack';
import Faq from './Faq.js';
import Checkbox from '@material-ui/core/Checkbox';
import Responsive from 'react-responsive';
import CircularProgress from '@material-ui/core/CircularProgress';
import InfoDialog from './InfoDialog.js'
import PricingAppBar from './PricingAppBar.js'
import SubscribeDialog from './SubscribeDialog.js';
import BudgetRequest from './BudgetRequest.js';

import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Redirect,
  withRouter,

} from 'react-router-dom'

import Checkout from './Checkout.js';

import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';



const Mobile = props => <Responsive {...props} maxWidth={767} />;
const Default = props => <Responsive {...props} minWidth={768} />;


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 50,

    color: "#203b60",
    textAlign: "center",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  MtextField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    // width: 50,

    color: "#203b60",
    fontSize: "18px",
    textAlign: "center",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  paperRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginBottom: '15px',
    width: '95%',

  },
  paperImp: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: '15px'
    // width:'100%'
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
    flexDirection: 'row'
  },
  root: {
    padding: 0,
    marginBottom: '1px'



  },
  checked: {
    color: green[500]
  },
});

class Main extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // step: 'confirmation',
      step: 'selection',
      users: 0,
      all_prices: false,
      selected_prices: false,
      period: "year",
      selected_apps: [],
      supports: false,
      selected_support: 0,
      selected_support_data: false,
      selected_pack: false,
      loading: true,
      session:{status:false, user:{name:"Ignacio Parszyk"}},
      serviceCount:0,
      subscribeDialog:false,
      budgetRequest:false,
      budgetLoading:false,
      info_dialog:{
        open:false,
        data:{
          name:"",
          description:""
        }
      }
    }
    this.userChange = this.userChange.bind(this);
    this.getPrices = this.getPrices.bind(this);
    this.setPeriod = this.setPeriod.bind(this);
    this.setSelectedApps = this.setSelectedApps.bind(this);
    this.handleImpType = this.handleImpType.bind(this);
    this.changeSupport = this.changeSupport.bind(this);
    this.getPacks = this.getPacks.bind(this);
    this.handlePack = this.handlePack.bind(this);
    this.addDependencies = this.addDependencies.bind(this);
    this.setSelectedApps = this.setSelectedApps.bind(this);
    this.isSelectedDependency = this.isSelectedDependency.bind(this);
    this.buyNow = this.buyNow.bind(this);
    this.saveSelection = this.saveSelection.bind(this);
    this.sendBudget = this.sendBudget.bind(this);
    this.handleSubscribeDialog = this.handleSubscribeDialog.bind(this);
    this.confirmSubscribeDialog = this.confirmSubscribeDialog.bind(this);
    this.handleBudgetRequest = this.handleBudgetRequest.bind(this);
    this.confirmBudgetRequest = this.confirmBudgetRequest.bind(this);
    this.goBack = this.goBack.bind(this);
    this.validateSelection = this.validateSelection.bind(this);
    this.openInfoDialog = this.openInfoDialog.bind(this);
    this.closeInfoDialog = this.closeInfoDialog.bind(this);


    this.supportRef = React.createRef()
    this.userRef = React.createRef()
    this.packRef = React.createRef()
    this.appRef = React.createRef()
    this.bottomPackRef = React.createRef()
    

  }

  userChange(event) {
    this.setState({
      users: event.target.value
    })
  }



  componentDidMount() {
    window.scrollTo(0, 0)
    if(this.props.history.location.state != undefined){
      this.setState(this.props.history.location.state.data)
    }
    else{
      this.getPrices()
      this.getSupport()
      this.getPacks()
    }
   
  }



  setPeriod(value) {
    this.setState({
      period: value
    })

    this.setPrices(value)

  }

  setPrices(period) {
    var selected_prices;
    if (period === 'year') {
      selected_prices = this.state.all_prices.year
    }
    else if (period === 'month') {
      selected_prices = this.state.all_prices.month
    }

    this.setState({ selected_prices: selected_prices, period: period })
  }

  getPrices() {
    return fetch("/api/kalenis_web/get_prices", {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      mode: 'cors',


    })
      .then((response) => {

        return response.json();
      }).then((json) => {
        var prices = json




        this.setState({ all_prices: prices, selected_prices: prices, prices: prices })

      });
  }

  getSupport() {
    return fetch("/api/kalenis_web/get_support", {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      mode: 'cors',


    })
      .then((response) => {

        return response.json();
      }).then((json) => {

        var supports = {
          'names': [],
          'prices': [],
          'service_list': [],
          'includes': [],
          'default': { "name": "Soporte" }
        }

        json.plans.map(function (plan) {
          supports['names'].push({ 'id': plan.id, 'name': plan.name, 'includes': plan.includes, 'prices': { 'year': plan.year, 'month': plan.month } })
          supports['includes'].push(plan.includes)
          supports['prices'].push({ 'year': plan.year, 'month': plan.month })
          if (plan.default) {
            supports['default'] = plan
          }



        })

        json.services.map(function (service) {
          supports['service_list'].push(service)
        })


        console.log("formatted support")
        console.log(supports)

        this.setState({ support_plans: json.plans, supports: supports, selected_support_data: 0 })

      });
  }

  getPacks() {
    return fetch("/api/kalenis_web/get_packs", {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      mode: 'cors',


    })
      .then((response) => {

        return response.json();
      }).then((json) => {
        console.log("support plans")
        console.log(json)
        var packs = {
          'names': [],
          'prices': [],
          'service_list': [],
          'includes': [],
          'default': { "name": "Soporte" }
        }

        json.packs.map(function (pack) {
          packs['names'].push({ 'id': pack.id, 'name': pack.name, price: { 'regular': pack.regular, 'new': pack.new }, 'includes': pack.includes })
          packs['includes'].push(pack.includes)
          packs['prices'].push({ 'regular': pack.regular, 'new': pack.new })
          if (pack.default) {
            packs['default'] = pack
          }



        })

        json.services.map(function (service) {
          packs['service_list'].push(service)
        })


        console.log("formatted Packs")
        console.log(packs)

        this.setState({ packs: json.packs, formatted_packs: packs, selected_pack: false, loading: false })

      });
  }

  addDependencies(app) {
    // console.log("Adding dependencies")
    console.log(app.depends)
    var selected = this.state.selected_apps


    var obj = selected.find(o => o.id === 1);

    if (app.depends.length > 0) {
      console.log("tiene dependencias")
      app.depends.map(function (dep) {
        console.log(".find")
        console.log(selected.find(app => app.id === dep))
        if (selected.find(app => app.id === dep) === undefined) {
          console.log("no está en las elegidas")
          var dep_to_add;
          if (this.state.prices.apps.find(app => app.id === dep) !== undefined) {
            dep_to_add = this.state.prices.apps.find(app => app.id === dep)
          }
          else if (this.state.prices.extra_apps.find(app => app.id === dep) !== undefined) {
            dep_to_add = this.state.prices.extra_apps.find(app => app.id === dep)
          }
          selected.push(dep_to_add)
          this.addDependencies(dep_to_add)

        }
      }.bind(this))
      console.log("Dependencie to Add")

      console.log(selected)
      this.setState({
        selected_apps: selected
      })






    }

  }

  isSelectedDependency(id) {
    console.log("Chequeando dependencia")

    var res = false;

    this.state.selected_apps.map(function (app) {

      if (app.depends.includes(id)) {
        console.log("es una dependencia")
        res = true
      }
    })
    return res
  }

  setSelectedApps(app) {

    console.log(app.id);
    var selected = this.state.selected_apps


    var app_ids = selected.map(function (app) {
      return app.id;
    })


    if (app_ids.includes(app.id) === false) {
      selected.push(app)
      this.addDependencies(app)
    }

    else if (app_ids.includes(app.id) === true) {

      console.log("isDependency")
      console.log(this.isSelectedDependency(app.id))
      if (this.isSelectedDependency(app.id) === false) {
        selected.map(function (obj) {
          if (obj.id === app.id) {
            selected.splice(selected.indexOf(obj), 1)
          }
        })
      }


    }

    console.log("Updated selection")
    console.log(selected)
    

    this.setState({
      selected_apps: selected
    })

  }

  handleImpType(event) {
    console.log("IMP TYPE")
    console.log(event.target.value)

    this.setState({
      implementation_type: event.target.value
    })

    if (event.target.value === 'pack') {
      console.log("es un pack")
      window.scrollTo(0, this.bottomPackRef.current.offsetTop)
      // window.scrollTo(0, document.body.scrollHeight)
    }
    if (event.target.value === 'auto') {
      this.setState({
        selected_pack_data: { 'id': 99, 'name': 'Auto Implementacion', 'regular': 0, 'new': 0 }
      })
    }
  }

  changeSupport(id) {
    console.log("Support")
    var selected_support_data = {};
    
    
    this.state.support_plans.map(function (plan) {
      if (plan.id === id) {
        selected_support_data = plan
      }
    })
    this.setState({
      selected_support: id,
      selected_support_data: selected_support_data,
      
    })
  }

  handlePack(id) {
    console.log("Handling pack")
    var selected_pack_data = {};
    if (id === 99) {
      selected_pack_data = { 'id': 99, 'name': 'Auto Implementacion', 'regular': 0, 'new': 0 }
    }
    else {
      this.state.packs.map(function (pack) {
        if (pack.id === id) {
          selected_pack_data = pack
        }
      })
    }


    this.setState({
      selected_pack: id,
      selected_pack_data: selected_pack_data
    })
  }

  validateSelection() {
    console.log("TIPO DE IMPLEMENTACIoN")
    console.log(this.state.implementation_type)
    console.log("tipo de pack")
    console.log(this.state.selected_pack)


    if (this.state.users === 0) {
      this.props.enqueueSnackbar('Debe Ingresar cuantos usuarios desea', { variant: 'info' })
      window.scrollTo(0, this.userRef.current.offsetTop)
      return false
    }
    if (this.state.selected_apps.length === 0) {
      this.props.enqueueSnackbar('Debe seleccionar al menos una aplicación', { variant: 'info' })
      window.scrollTo(0, this.appRef.current.offsetTop)
      return false

    }

    if (this.state.selected_support === 0) {
      this.props.enqueueSnackbar('Debe seleccionar su plan de soporte', { variant: 'info' })
      window.scrollTo(0, this.supportRef.current.offsetTop)
      return false
    }



    // if (this.state.implementation_type === undefined) {
    //   this.props.enqueueSnackbar('Debe seleccionar su tipo de implementación', { variant: 'info' })
    //   window.scrollTo(0, this.packRef.current.offsetTop)
    //   return false
    // }

    if (this.state.selected_pack === false) {
      this.props.enqueueSnackbar('Debe seleccionar su tipo de implementación', { variant: 'info' })
      window.scrollTo(0, this.packRef.current.offsetTop)
      return false
    }







    return true;

  }

  buyNow() {

    // this.validateSelection()
    // window.scrollTo(0, this.userRef.current.offsetTop) 
    // this.props.enqueueSnackbar('Successfully fetched the data.', { variant: 'error' })

    if (this.validateSelection() === true) {

      // this.props.history.push('/order', {state:{ detail: this.state }})
     
      this.props.history.push({
        pathname: '/review',
        // search: '?query=abc',
        state: { data: this.state }
      })
      

      // this.setState({
      //   'step': "confirmation"
      // })
    }

    // 
  }

  handleSubscribeDialog(){
    this.setState({
      subscribeDialog: !this.state.subscribeDialog
    })
  }

  confirmSubscribeDialog(){
    alert("Gracias")
    this.handleSubscribeDialog()
  }



  handleBudgetRequest(){

    if (this.validateSelection() === true) {
      this.setState({
        budgetRequest: !this.state.budgetRequest
      })
    }
   
  }

  confirmBudgetRequest(data){
   
    console.log(data)

    
    this.setState({ budgetLoading:true})
    this.sendBudget(data)
    // this.setState({
    //   loading:true
    // })
    
  }

   sendBudget(data) {
    // e.preventDefault()
    console.log("Submmiting form")

    var body_req = JSON.stringify({
      company: data.company,
      name: data.name,
      email:data.email,
      services:{"selected_apps":this.state.selected_apps.map(function (app) {return app.id}), "users":this.state.users, "support":this.state.selected_support, "pack":this.state.selected_pack}
      

    })
    console.log("BODY FOR BUDGET")
    console.log(body_req)
    console.log("STATE")
    console.log(this.state)



    return fetch("/api/kalenis_web/send_proposal", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: body_req

    })
      .then((response) => {


        return response.json();
      }).then((json) => {

        console.log("RAW BUDGET JSON")
        console.log(json)
        this.setState({budgetRequest:false,budgetLoading:false})
        this.openInfoDialog("Muchas Gracias", "Recibirá su propuesta por correo electrónico en unos minutos")

       
        

      })
  }


  



  saveSelection() {
    console.log("Saving Selection")
    if(this.state.session.status === false){
      this.handleBudgetRequest()
    }
    
  }



  goBack() {
    this.setState({
      step: 'selection'
    })
  }

  openInfoDialog(name, description){
    this.setState({
      info_dialog:{
        open:true,
        data:{
          name:name,
          description:description
        }
      }
    })
  }

  closeInfoDialog(){
    this.setState({
      info_dialog:{open:false, data:{}}
    })
  }





  render() {
    const { classes } = this.props;
    return (
      <div>

        <InfoDialog open={this.state.info_dialog.open} close={this.closeInfoDialog} data={this.state.info_dialog.data}/>
        {/* <div className="container-custom" id="funcionalidades"> */}
        {/* <div  className="funcionalidades-titulo" style={{marginTop:'88px'}} id="top"> */}
        <div  style={{ marginTop: '88px' }}>
          <PricingAppBar session={this.state.session} cartBadge={this.state.selected_apps.length} />
        </div>

        {/* <img class="float-right d-none d-md-block" src="funcionalidades-titulo.png" width="240" height="150" */}
        {/* alt="Kalenis Funcionalidades" /> */}
        {/* </div>
        </div> */}
        <SubscribeDialog open={this.state.subscribeDialog} confirm={this.confirmSubscribeDialog} close={this.handleSubscribeDialog}/>
        <BudgetRequest open={this.state.budgetRequest} confirm={this.confirmBudgetRequest} close={this.handleBudgetRequest} loading={this.state.budgetLoading}/>

        {this.state.loading === true &&

          <div className="loading-indicator">
            <CircularProgress className={classes.progress} />

          </div>

        }

        {this.state.step === 'selection' && this.state.loading === false &&

          <CSSTransition
            in
            appear

            timeout={500}
            classNames="fade200"
          >

            <div className="row main" style={{marginRight:'0px'}}>




              <div className="col-md-8" >



                <div className="col-md-12">
                  <div ref={this.userRef} className="pricing-title">Selecciona tus usuarios</div>


                </div>

                <div className="col-md-12">

                  <CSSTransition
                    in
                    appear

                    timeout={600}
                    classNames="fade500"
                  >
                  
                    <Paper className={classes.paperRoot} elevation={1}>


                      <Default>
                        <TextField
                          id="users_qty"
                          // label="Number"
                          value={this.state.users}
                          onChange={this.userChange}
                          type="number"
                          // className={classes.textField}
                          InputProps={{
                            classes: {
                              root: classes.textField,
                              input: { textAlign: 'center' }

                            },
                          }}
                          // inputProps={{textAlign:'center'}}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          margin="normal"
                        />

                        {this.state.prices && this.state.loading === false &&
                          <span style={{ lineHeight: "4", marginLeft: "15px", color: 'rgba(0, 0, 0, 0.54)', fontWeight: '500' }}>Usuarios x $ {this.state.prices.user[this.state.period] - (this.state.prices.user[this.state.period] * this.state.prices.user.discount_new_user)} USD/mes <span style={{ color: 'red', textDecoration: 'line-through', marginLeft: '3px' }}>$ {this.state.prices.user[this.state.period]} USD/mes</span></span>
                        }
                        
                      </Default>

                      <Mobile>
                        <div className="row text-center">
                          <TextField
                            id="users_qty"

                            value={this.state.users}
                            onChange={this.userChange}
                            type="number"
                            className={classes.MtextField}

                            InputProps={{
                              classes: {
                                root: classes.MtextField,
                                input: { textAlign: 'center' }

                              },
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            margin="normal"
                          />
                        </div>

                        <div className="row">
                          {this.state.prices && this.state.loading === false &&
                            <span style={{ marginLeft: "15px", color: 'rgba(0, 0, 0, 0.54)', fontWeight: '500' }}>Usuarios x $ {this.state.prices.user[this.state.period] - (this.state.prices.user[this.state.period] * this.state.prices.user.discount_new_user)} USD/mes <span style={{ color: 'red', textDecoration: 'line-through', marginLeft: '3px' }}>$ {this.state.prices.user[this.state.period]} USD/mes</span></span>
                          }
                        </div>


                      </Mobile>






                    </Paper>
                    
                  </CSSTransition>

                </div>



                <CSSTransition
                  //  key={item.id}
                  in
                  appear
                  timeout={500}
                  classNames="fade500"
                >
                  <div className="col-md-12 ">
                    <div className="pricing-title">Selecciona tus Aplicaciones</div>

                  </div>
                </CSSTransition>
                {/* <Paper className={classes.paperRoot} elevation={1}> */}

                {this.state.prices && this.state.loading === false &&

                  <div ref={this.appRef} className="col-md-12" >

                    <AppsGrid prices={this.state.prices.apps} period={this.state.period} selected_apps={this.state.selected_apps} setSelectedApps={this.setSelectedApps} />
                    {/* <div className="col-md-12"> */}
                    <div className="pricing-title">Integraciones Adicionales</div>
                    {/* </div> */}
                    <AppsGrid prices={this.state.prices.extra_apps} period={this.state.period} selected_apps={this.state.selected_apps} setSelectedApps={this.setSelectedApps} />
                  </div>



                }


                <CSSTransition
                  //  key={item.id}
                  in
                  appear
                  timeout={900}
                  classNames="fade500"
                >

                  <div ref={this.supportRef} className="col-md-12 user-selection">
                    <div className="pricing-title">Plan de Asistencia</div>
                    <div style={{ color: "rgba(0, 0, 0, 0.54)" }} > Una gran solución, respaldada por una gran asistencia </div>

                    {this.state.supports != false &&
                      <div >

                        {/* <Paper className={classes.paperImp} elevation={1}> */}



                        <SupportGrid plans={this.state.supports} period={this.state.period} changeSupport={this.changeSupport} selected_support={this.state.selected_support} />


                        {/* </Paper> */}
                      </div>
                    }
                  </div>
                </CSSTransition>





              </div>

              {this.state.prices && this.state.selected_suport_data !== false && this.state.loading === false &&
                <CSSTransition
                  //  key={item.id}
                  in
                  appear
                  timeout={500}
                  classNames="fade500"
                >

                  <div className="col-md-4 price-main">
                    <PriceCalc setPeriod={this.setPeriod} period={this.state.period} users={this.state.users} prices={this.state.prices} apps={this.state.selected_apps} support={this.state.selected_support_data} buy={this.buyNow} saveSelection={this.saveSelection} pack={this.state.selected_pack_data} />
                  </div>


                </CSSTransition>
              }




              <CSSTransition
                //  key={item.id}
                in
                appear
                timeout={500}
                classNames="fade800"
              >
                <div ref={this.packRef} className="col-md-12  section-margin">

                  <div className="col-md-12">
                    <div className="pricing-title">Take Off Packs <i className="fa fa-1x fa-plane-departure"></i></div>



                    <div style={{ color: "rgba(0, 0, 0, 0.54)" }}>Impulse la implementación, la productividad y el retorno de la inversión con nuestros Take Off Packs.<br></br> Nuestro equipo te acompañará hacia el <strong style={{ color: "#203b60" }}> éxito de la implementación inicial.</strong> </div>
                  </div>




                  <div className="col-md-12">

                    {this.state.formatted_packs && this.state.loading === false &&
                      <PackGrid plans={this.state.formatted_packs} selected_pack={this.state.selected_pack} handlePack={this.handlePack} />

                    }


                    <div className="col-md-12 text-center section-margin">
                      <span>
                        Auto Implementación <strong>$ 0 USD</strong>
                        <Checkbox
                          checked={this.state.selected_pack === 99 ? true : false}
                          value={99}
                          color="primary"
                          onChange={(e) => this.handlePack(99)}
                          classes={{
                            root: classes.root,
                            // checked: classes.checked,
                          }}
                        />
                      </span>
                      <div style={{ color: "rgba(0, 0, 0, 0.54)" }}>No deseo un Take Off Pack por el momento, adoptaré la solución con la ayuda de <strong style={{ color: "#203b60" }}> Kalenis Learning Center</strong>   </div>
                    </div>

                  </div>

                </div>
              </CSSTransition>




              <div ref={this.bottomPackRef} className="col-md-12">

                <div className="col-md-12">

                  <Faq />

                </div>
              </div>
            </div>
          </CSSTransition>
        }

        {/* {this.state.step === 'confirmation' &&

           

           <MainConfirmation selected_apps={this.state.selected_apps} period={this.state.period} prices={this.state.prices} users={this.state.users} support={this.state.selected_support_data} back={this.goBack} pack={this.state.selected_pack_data} />
         }  */}

      </div>

    );
  }
}


Main.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withSnackbar(withStyles(styles)(withRouter(Main)));
// export default AppsGrid;